// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const LocationIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7669 4.10078C9.9875 4.10078 6.10095 7.98839 6.10095 12.7678C6.10095 16.4569 11.8362 22.3823 14.7669 25.0241C17.6976 22.3823 23.4329 16.4569 23.4329 12.7678C23.4329 7.98839 19.5463 4.10078 14.7669 4.10078ZM14.7668 27.4727C14.5252 27.4727 14.2836 27.3897 14.084 27.2216C13.0546 26.3414 4 18.458 4 12.7679C4 6.83088 8.83193 2 14.7668 2C20.7017 2 25.5336 6.83088 25.5336 12.7679C25.5336 18.458 16.479 26.3414 15.4496 27.2216C15.25 27.3897 15.0084 27.4727 14.7668 27.4727Z"
        fill={iconColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7671 9.61662C13.0339 9.61662 11.6158 11.0305 11.6158 12.7679C11.6158 14.5063 13.0339 15.9191 14.7671 15.9191C16.5003 15.9191 17.9183 14.5063 17.9183 12.7679C17.9183 11.0305 16.5003 9.61662 14.7671 9.61662ZM14.7669 18.0201C11.8677 18.0201 9.51477 15.664 9.51477 12.768C9.51477 9.87196 11.8677 7.51587 14.7669 7.51587C17.666 7.51587 20.019 9.87196 20.019 12.768C20.019 15.664 17.666 18.0201 14.7669 18.0201Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default LocationIcon;
